export const EMAIL_CONFIRM_FETCH_START = 'EMAIL_CONFIRM_FETCH_START';
export const EMAIL_CONFIRM_FETCH_SUCCESS = 'EMAIL_CONFIRM_FETCH_SUCCESS';
export const EMAIL_CONFIRM_FETCH_FAIL = 'EMAIL_CONFIRM_FETCH_FAIL';
